<template>
    <div>
        <p class="count-table">
            {{ (page - 1) * perPage }} {{ $t("splitter_pagination") }} <span
                v-if="page * perPage < participants.nb_inscriptions">{{ page * perPage }}</span><span v-else>{{
                    participants.nb_inscriptions }}</span> /
            {{ participants.nb_inscriptions }}
        </p>
    </div>
</template>

<script>
export default {
    computed: {
        page() {
            return this.$store.getters["listCoureurs/page"];
        },
        perPage() {
            return this.$store.getters["listCoureurs/perPage"];
        },
        participants() {
            return this.$store.getters["listCoureurs/participants"];
        }
    },

    methods: {
        get_translated_status(status) {
            return this.$store.getters["listCoureurs/get_translated_status"](status);
        }
    }
}
</script>

<style lang="scss" scoped></style>